// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".floating-bottom__components>:not(.floating-bottom__snackbars){margin-bottom:10px!important;position:relative!important}.floating-bottom__components>.fixed{position:fixed!important}.floating-bottom__components>.fixed--full-width{left:0;right:0}.floating-bottom__components>.fixed--full-height{bottom:0;top:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
